import React from 'react';
import { CodeActivationStep as CodeActivationStepForm } from '@fiverr-private/code_activation';
import { useIdentificationContext, reportIdentificationCompletion } from '@fiverr-private/identification_core';
import { useStepsContext } from '../../StepsContext';
import { globalBigQueryReporter } from '../../../events';

export const CodeActivationStep = () => {
    const { goToStep } = useStepsContext();
    const { email, finishSigningFlowAndNavigate, isCodeActivationSkippable } = useIdentificationContext();

    return (
        <CodeActivationStepForm
            email={email}
            isSkippable={isCodeActivationSkippable}
            onSkip={finishSigningFlowAndNavigate}
            onSuccess={finishSigningFlowAndNavigate}
            onGoToHomepage={reportIdentificationCompletion}
            onGoToChangeEmail={() => goToStep('change_email')}
            bigQueryEnrichment={globalBigQueryReporter.enrichment}
        />
    );
};
